export default {
  text: 'Du har optjent {{points}} point ({{amount}}) på denne bestilling',
  button: 'Log ind og indløs point',
};
